var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"hidden","width":"100%","height":"100%"}},[_c('img',{attrs:{"src":_vm.propValue}})])}
var staticRenderFns = []

export { render, staticRenderFns }